module.exports = __webpack_public_path__ + "img/mesa_l001e.b5e70602.png";